import { SECURE_COOKIE } from "configs/AppConfig"

// Set cookie
export const setCookie = (name: string, value: string | undefined) => {
  const encodedValue = value ? encodeURIComponent(value) : ""
  document.cookie = `${name}=${encodedValue}; Path=/; SameSite=Strict${SECURE_COOKIE ? `; Secure` : ""}`
}

// Get cookie value
export const getCookie = (name: string): string | undefined => {
  const regexp = new RegExp(`(?:^|; )${name}=([^;]*)(?:$|; )`)
  const match = document.cookie.match(regexp)
  if (match) {
    return decodeURIComponent(match[1])
  } else {
    return undefined
  }
}
